/* ============================================================
   AAR Jewels - lightweight carousel engine (no dependencies).
   Enhances any [data-aar-carousel] with a [data-aar-track] child.
   Optional: [data-aar-prev], [data-aar-next], [data-aar-dots],
   and data-autoplay="<ms>" on the root for auto-rotation.
   ============================================================ */
(function () {
  function initCarousel(root) {
    if (!root || root.dataset.aarInit === '1') return;
    var track = root.querySelector('[data-aar-track]');
    if (!track) return;
    root.dataset.aarInit = '1';

    var prev = root.querySelector('[data-aar-prev]');
    var next = root.querySelector('[data-aar-next]');
    var dotsWrap = root.querySelector('[data-aar-dots]');
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function step() {
      if (slides.length > 1) {
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      }
      return track.clientWidth;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    function activeIndex() {
      return Math.round(track.scrollLeft / (step() || 1));
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aar-carousel__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () {
          track.scrollTo({ left: i * step(), behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function sync() {
      var idx = activeIndex();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    sync();

    var interval = parseInt(root.dataset.autoplay || '0', 10);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (interval > 0 && slides.length > 1 && !reduce) {
      var timer = null;
      var start = function () {
        stop();
        timer = window.setInterval(function () {
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          if (atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            go(1);
          }
        }, interval);
      };
      var stop = function () { if (timer) { window.clearInterval(timer); timer = null; } };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      start();
    }
  }

  // Scroll-reveal for .aar-reveal elements (runs on every page, not just the homepage).
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.aar-reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aar-carousel]').forEach(initCarousel);
    initReveal(scope);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Shopify theme editor: (re)initialise when a section is loaded.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
